import { useEffect, useState } from 'react';

import { match } from 'ts-pattern';

import { type StabilityStatus, type Status, webSocketClient } from '@/shared/api/web-socket-client';

export function useConnectionAlert(): 'reconnecting' | 'unstable' | null {
    const [status, setStatus] = useState<Status>(webSocketClient.getStatus());
    const [stability, setStability] = useState<StabilityStatus>(
        webSocketClient.getStabilityStatus(),
    );

    useEffect(() => {
        const abortController = new AbortController();
        const { signal } = abortController;

        webSocketClient.addStatusListener(setStatus, { signal });
        webSocketClient.addStabilityListener(setStability, { signal });

        return () => abortController.abort();
    }, []);

    return match({ status, stability })
        .with({ status: 'reconnecting' }, () => 'reconnecting' as const)
        .with({ stability: 'unstable' }, () => 'unstable' as const)
        .otherwise(() => null);
}
